<template>
  <div ref="categoryDrop">
    <div v-for="(item, index) in list" :key="index" >      
        <vs-dropdown-group v-if="item.children" vs-collapse :vs-label="item.categoryName"> 
          <getDropChild :list="item.children"></getDropChild>
        </vs-dropdown-group>     
        <vs-dropdown-item v-else @click.stop="selectItem(item)"> 
          {{item.categoryName}}     
        </vs-dropdown-item>
    </div>  
  </div>
</template>

<script>
  import {bus} from '@/bus.js'
  export default {
    name: "getDropChild",
    props: {
      list: Array 
      // ,
      // categoryDrop : {
      //   type: Boolean
      // }
    },
    data(){
      return{
        
      }
    },
    mounted(){
      //this.categoryDrop ? bus.$emit("updateCategoryDrop", true) : '';
    },
    methods:{
      selectItem(item){
        bus.$emit("updateCategoryId", item.id, item.categoryName);
        //bus.$emit("updateCategoryDrop", false);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../commodity.scss';
</style>
